import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { Reveal, SectionLabel } from "@/lib/Reveal";
import { POSTS } from "@/lib/blog";

export const Blog = () => {
  return (
    <section id="blog" data-testid="blog-section" className="py-20 lg:py-28 bg-[#0C0C0C] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Reveal><SectionLabel>10 / From the van</SectionLabel></Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white mt-4">
                Plumbing & heating,<br />explained plainly.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <div className="flex items-center gap-4">
              <p className="max-w-sm text-neutral-400 text-sm leading-relaxed">
                Honest advice from 15+ years on the tools — what we do, what things
                should cost, and when you actually need to call someone.
              </p>
              <a href="/blog" data-testid="blog-view-all-link" className="shrink-0 font-mono text-xs uppercase tracking-[0.15em] text-torch border border-torch/40 hover:bg-torch/10 px-4 py-2.5 rounded-sm transition-colors">
                All articles
              </a>
            </div>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {POSTS.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.1} className="h-full">
              <Link
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group flex flex-col h-full bg-surface border border-neutral-800 hover:border-torch rounded-sm overflow-hidden transition-all hover:-translate-y-1"
              >
                <div className="overflow-hidden aspect-[16/10]">
                  <img
                    src={p.image}
                    alt={p.title}
                    loading="lazy"
                    className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                  />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="font-mono text-[10px] tracking-[0.2em] text-torch uppercase">{p.date}</span>
                    <span className="flex items-center gap-1.5 font-mono text-[10px] tracking-wider text-neutral-500 uppercase">
                      <Clock className="w-3 h-3" /> {p.readTime}
                    </span>
                  </div>
                  <h3 className="font-display font-bold text-lg text-white leading-snug flex-1">{p.title}</h3>
                  <p className="mt-3 text-sm text-neutral-400 leading-relaxed line-clamp-3">{p.excerpt}</p>
                  <span className="mt-5 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.15em] text-torch">
                    Read article <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
